import React from 'react';
import PropTypes from 'prop-types';
import { usePrevious } from '@plone/volto/helpers';
import { BlockDataForm } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import { MemberListSchema } from './schema';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';
import { difference } from '@plone/volto/helpers';
import { replaceItemOfArray } from '@plone/volto/helpers';

const MemberListData = (props) => {
  const { block, data, onChangeBlock } = props;
  const { columns } = props.data;
  const previous = usePrevious(columns);
  const intl = useIntl();
  const schema = MemberListSchema({ ...props, intl });

  React.useEffect(() => {
    if (previous) {
      const diff = difference(columns, previous);
      const index = diff.findIndex((val) => val);
      if (diff[index]?.href?.[0]) {
        onChangeBlock(block, {
          ...data,
          columns: replaceItemOfArray(data.columns, index, {
            ...data.columns[index],
            title: diff[index].href[0].title,
          }),
        });
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [columns]);

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

MemberListData.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default withObjectBrowser(MemberListData);
